<template>
    <div>
      <report-header @generate="load" @filterChanged="filterChanged"
        @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
        :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
        @limitChanged="limitChanged"
        @download="download"
        @onChangeAccsGroup="onChangeAccsGroup"/>

      <basic-table
        @Filtred="Filtred"
        :items="telephonyDirections"
        :fields="telephonyDirectionsFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
</template>

<script>
import download from 'downloadjs'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        limit: 500,
        download: 0
      },
      telephonyDirections: [],
      telephonyDirectionsFields: [
        {key: 'dir_id', label: this.$i18n.t('Direction ID'), sortable: true},
        {key: 'dir_name', label: this.$i18n.t('Direction name'), sortable: true},
        {key: 'duration', label: this.$i18n.t('Aggregate duration'), sortable: true},
        {key: 'cost', label: this.$i18n.t('Aggregate cost'), sortable: true},
        {key: 'calls_cnt', label: this.$i18n.t('Calls count'), sortable: true},
        {key: 'nonzero_duration_calls_cnt', label: this.$i18n.t('Calls count with nonzero duration'), sortable: true}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      selectAccsGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      }
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenerateClick = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart

      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_TELEPHONY_DIRECTIONS', this.getStore).then(response => {
        if (isGenerateClick) {
          this.telephonyDirections = this.$store.getters['Reports/TELEPHONY_DIRECTIONS']
        } else {
          download(this.$store.getters['Reports/TELEPHONY_DIRECTIONS'], 'report_services_tel_directions.csv', 'text/csv')
        }
      })
      this.loadDone()
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_TEL_DIRS')
      this.getStore.download = 0
      this.totalRows = 0
      this.telephonyDirections = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = value
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/services/telephonyDirectionsReport/main.vue